export default __webpack_public_path__ + "static/media/phone.8d80d9fa.svg";